import { Columns } from '@shared/interfaces/table/column-config';
import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';

/**
 * hasBalanceSupplier Partial Status Cell
 * Boolean state, shows red/green
 */
export const hasBalanceSupplierPartial: Columns<any> = {
  title: 'Elleverandør',
  key: 'hasBalanceSupplier',
  cellRenderer: StatusCellComponent,
  cellRendererParams: {
    0: { color: 'bg-red-500', label: 'common.no' },
    1: { color: 'bg-green-500', label: 'common.yes' },
  }
}
